import { render, staticRenderFns } from "./TouchSpin.vue?vue&type=template&id=b936e662&"
import script from "./TouchSpin.vue?vue&type=script&lang=js&"
export * from "./TouchSpin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports